
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2_jzyv5"];
var parcelRegister = parcelRequire.register;
parcelRegister("8mF5Z", function(module, exports) {

$parcel$export(module.exports, "RistrettoPlayerWrapper", function () { return $870d24e797f71b04$export$713c91a4a6443f0f; });

var $bsvQL = parcelRequire("bsvQL");

var $hJ7nZ = parcelRequire("hJ7nZ");

var $4gxuw = parcelRequire("4gxuw");

var $giOKx = parcelRequire("giOKx");
const $870d24e797f71b04$var$statsConfig = {
    framesDecoded: {
        originalPath: 'inbound-rtp:video.framesDecoded',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    nackCount: {
        originalPath: 'inbound-rtp:video.nackCount',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    totalFreezesDuration: {
        originalPath: 'inbound-rtp:video.totalFreezesDuration',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    totalPausesDuration: {
        originalPath: 'inbound-rtp:video.totalPausesDuration',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    fecPacketsReceived: {
        originalPath: 'inbound-rtp.fecPacketsReceived',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    fecPacketsDiscarded: {
        originalPath: 'inbound-rtp.fecPacketsDiscarded',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    framesReceived: {
        originalPath: 'inbound-rtp:video.framesReceived',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    packetsLost: {
        originalPath: 'inbound-rtp.packetsLost',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    packetsDiscarded: {
        originalPath: 'inbound-rtp.packetsDiscarded',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    packetsReceived: {
        originalPath: 'inbound-rtp.packetsReceived',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    totalRoundTripTime: {
        originalPath: 'candidate-pair.totalRoundTripTime',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'nonzero'
    },
    responsesReceived: {
        originalPath: 'candidate-pair.responsesReceived',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'nonzero'
    },
    audioJitter: {
        originalPath: 'inbound-rtp:audio.jitter',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    },
    videoJitter: {
        originalPath: 'inbound-rtp:video.jitter',
        modifier: 'raw',
        reducer: 'sum',
        filter: 'number'
    }
};
const $870d24e797f71b04$var$statsSchemeKeys = Object.keys($870d24e797f71b04$var$statsConfig);

class $870d24e797f71b04$export$713c91a4a6443f0f extends (0, $4gxuw.AbstractWrapper) {
    constructor(eventBusInstance, options = {}){
        super(eventBusInstance, options), this._ristrettoModuleCache = null, this._abrResolutions = [], this._isABREnabled = false, this._isLoadingPlayerModule = false, this._logLevels = [], this._ristrettoPlaybackStateToMMPStateMap = null;
        this._toggleTurnServersListener = eventBusInstance.subscribe((0, $giOKx.EPlayersEvents).TOGGLE_TURN_SERVERS, this._toggleTURNServers);
    }
    destroy() {
        this._eventBusInstance.unsubscribe(this._toggleTurnServersListener);
        return super.destroy();
    }
    setStreamConfig(config) {
        if (!config?.WebRTCSignallingUrl) {
            this._lastKnownStreamConfig = null;
            return this;
        }
        this._lastKnownStreamConfig = {
            WebRTCStreamId: config.WebRTCStreamId,
            WebRTCACLToken: config?.WebRTCACLToken,
            WebRTCSignallingUrl: config?.WebRTCSignallingUrl
        };
        this._setStreamConfig();
        return this;
    }
    enableAbr() {
        this._isABREnabled = true;
        this._playerInstance?.enableABR();
        return this;
    }
    disableAbr() {
        this._isABREnabled = false;
        this._playerInstance?.disableABR();
        return this;
    }
    setAbrResolutions(resolutions) {
        this._abrResolutions = resolutions;
        this._playerInstance?.setAbrResolutionsVariants(resolutions);
        return this;
    }
    setLoggerLevel(levels) {
        this._playerInstance?.setLoggerLevels(levels);
        this._logLevels = levels;
    }
    setResolutionByName(resolutionName) {
        this._playerInstance?.setQualityByName(resolutionName);
        return this;
    }
    setResolutionByBitrate(bitrate) {
        this._playerInstance?.setQualityByBitrate(bitrate);
        return this;
    }
    recreatePlayerInstance() {
        if (this._playerInstance && !this._persistent) {
            this.destroy();
            this._playerInstance = null;
        }
        this._createPlayerInstance();
    }
    setPlayerConfig(config) {
        this._lastKnownConfig = config;
        if (!this._lastKnownConfig.peerConnectionConfig) this._lastKnownConfig.peerConnectionConfig = {};
        if (!this._lastKnownConfig.peerConnectionConfig?.statsCollectionScheme) this._lastKnownConfig.peerConnectionConfig = {
            statsCollectionScheme: $870d24e797f71b04$var$statsConfig
        };
        else this._lastKnownConfig.peerConnectionConfig.statsCollectionScheme = {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...this._lastKnownConfig.peerConnectionConfig.statsCollectionScheme,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            ...$870d24e797f71b04$var$statsConfig
        };
        this._playerInstance?.setConfig(config, true);
        return this;
    }
    get version() {
        return this._playerInstance?.version;
    }
    _attachEventListeners() {
        if (!this._ristrettoModuleCache || !this._playerInstance) return;
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.DEBUGGER_CONNECTED, this._onDebuggerConnected);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.EPlayerEvent.PLAY_STATE_CHANGED, this._onPlaybackStateChanged);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.ERROR, this._onRistrettoError);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.PEER_METRICS_AVAILABLE, this._onPeerMetricsAvailable);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.LIFECYCLE_EVENT, this._onLifecycleEventReported);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.LIFECYCLE_ERROR, this._onLifecycleErrorReported);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTION_SWITCH_AUTO, this._onRenditionSwitchAuto);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable);
        this._playerInstance.addEventListener(this._ristrettoModuleCache.ECommonEvents.QUALITY_CHANGED, this._onQualityChanged);
    }
    _detachEventListeners() {
        if (!this._ristrettoModuleCache || !this._playerInstance) return;
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.DEBUGGER_CONNECTED, this._onDebuggerConnected);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.EPlayerEvent.PLAY_STATE_CHANGED, this._onPlaybackStateChanged);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.ERROR, this._onRistrettoError);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.PEER_METRICS_AVAILABLE, this._onPeerMetricsAvailable);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTION_SWITCH_AUTO, this._onRenditionSwitchAuto);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.RESOLUTIONS_AVAILABLE, this._onResolutionsAvailable);
        this._playerInstance.removeEventListener(this._ristrettoModuleCache.ECommonEvents.QUALITY_CHANGED, this._onQualityChanged);
    }
    _createPlayerInstance() {
        if (!this._ristrettoModuleCache) {
            this._loadRistrettoModule();
            return;
        }
        if (!this._persistent || !this._playerInstance) {
            this._destroyPlayerInstance();
            this._playerInstance = new this._ristrettoModuleCache.Player();
        }
        if (this._lastKnownConfig) this._playerInstance.setConfig(this._lastKnownConfig, true);
        this._playerInstance?.setConfig({
            peerConnectionConfig: {
                statsCollectionScheme: $870d24e797f71b04$var$statsConfig,
                statsGatheringPeriod: 500
            }
        });
        this._setStreamConfig();
        this._playerInstance.setAppKey(this._appKey);
        if (this._videoElement) this._playerInstance.setVideoElement(this._videoElement);
        this._attachEventListeners();
        this._playerInstance?.setAppKey('callbackApp');
        if (this._isStarted) this._playerInstance?.start();
        if (this._isABREnabled) this._playerInstance?.enableABR();
        else this._playerInstance?.disableABR();
        this._playerInstance?.setAbrResolutionsVariants(this._abrResolutions);
        this._playerInstance?.setLoggerLevels(this._logLevels);
    }
    _setStreamConfig() {
        if (this._playerInstance && this._lastKnownStreamConfig) this._playerInstance?.setStreamConfig({
            aclToken: this._lastKnownStreamConfig.WebRTCACLToken,
            streamId: this._lastKnownStreamConfig.WebRTCStreamId,
            wsUrl: this._lastKnownStreamConfig.WebRTCSignallingUrl
        }, true);
    }
    async _loadRistrettoModule() {
        if (this._isLoadingPlayerModule) return;
        this._isLoadingPlayerModule = true;
        const { EStreamStatus: EStreamStatus, Player: Player, ECommonEvents: ECommonEvents, EPlayerEvent: EPlayerEvent } = await (parcelRequire("h9Af4"));
        this._ristrettoModuleCache = {
            EStreamStatus: EStreamStatus,
            Player: Player,
            ECommonEvents: ECommonEvents,
            EPlayerEvent: EPlayerEvent
        };
        this._ristrettoPlaybackStateToMMPStateMap = {
            [EStreamStatus.UNKNOWN]: (0, $hJ7nZ.EPlaybackState).IDLE,
            [EStreamStatus.CONNECTING]: (0, $hJ7nZ.EPlaybackState).LOADING,
            [EStreamStatus.LIVE]: (0, $hJ7nZ.EPlaybackState).PLAYING,
            [EStreamStatus.FINISHED]: (0, $hJ7nZ.EPlaybackState).PAUSED,
            [EStreamStatus.ERRORED]: (0, $hJ7nZ.EPlaybackState).ERROR
        };
        this._isLoadingPlayerModule = false;
        this._createPlayerInstance();
    }
    _onDebuggerConnected({ detail: { debuggerUrl: debuggerUrl } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).DEBUGGER_CONNECTED, {
            debuggerUrl: debuggerUrl
        });
    }
    _onPlaybackStateChanged({ detail: { prevState: prevState, nextState: nextState } }) {
        if (!this._ristrettoPlaybackStateToMMPStateMap) return;
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).PLAYBACK_STATE_CHANGED, {
            nextState: this._ristrettoPlaybackStateToMMPStateMap[nextState],
            prevState: this._ristrettoPlaybackStateToMMPStateMap[prevState]
        });
    }
    _onRistrettoError({ detail: detail }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).ERROR, {
            error: new Error(`Ristretto player error: ${detail.info}`),
            isFatal: detail.isFatal,
            playerType: (0, $hJ7nZ.EPlayerType).WEBRTC
        });
    }
    _onPeerMetricsAvailable({ detail: { metrics: metrics } }) {
        const validMetrics = $870d24e797f71b04$var$statsSchemeKeys.reduce((s, key)=>{
            if (Object.hasOwn(metrics, key)) s[key] = metrics[key];
            return s;
        }, {});
        this._metricsCollector?.registerMetrics(validMetrics);
    }
    _onLifecycleEventReported({ detail: { eventType: eventType } }) {
        this._metricsCollector?.registerEvent(eventType);
    }
    _onLifecycleErrorReported({ detail: { errorType: errorType, nativeError: nativeError } }) {
        this._metricsCollector?.registerEvent(errorType, {
            errorMessage: nativeError?.message || ''
        });
    }
    _onResolutionsAvailable({ detail: { resolutions: resolutions } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).RESOLUTIONS_AVAILABLE, {
            resolutions: resolutions
        });
    }
    _onRenditionSwitchAuto({ detail: { prevResolution: prevResolution, nextResolution: nextResolution } }) {
        this._metricsCollector?.registerEvent('RenditionSwitchedAuto', {
            prevResolution: prevResolution,
            nextResolution: nextResolution
        });
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).AUTO_RESOLUTION_SWITCHED, {
            name: nextResolution
        });
    }
    _toggleTURNServers({ shouldUseTURNServers: shouldUseTURNServers }) {
        this._playerInstance?.toggleTURNServersUsage(shouldUseTURNServers);
    }
    _onQualityChanged({ detail: { name: name } }) {
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).RESOLUTION_SWITCHED, {
            name: name
        });
    }
}
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onDebuggerConnected", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onPlaybackStateChanged", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onRistrettoError", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onPeerMetricsAvailable", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onLifecycleEventReported", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onLifecycleErrorReported", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onResolutionsAvailable", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onRenditionSwitchAuto", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_toggleTURNServers", null);
(0, $bsvQL.__decorate)([
    (0, $hJ7nZ.bind)
], $870d24e797f71b04$export$713c91a4a6443f0f.prototype, "_onQualityChanged", null);

});
parcelRegister("4gxuw", function(module, exports) {

$parcel$export(module.exports, "AbstractWrapper", function () { return $7f52331869660786$export$58bff5bd2c5ee4fc; });

var $giOKx = parcelRequire("giOKx");
class $7f52331869660786$export$58bff5bd2c5ee4fc {
    constructor(eventBusInstance, options = {}){
        this._videoElement = null;
        this._lastKnownConfig = {};
        this._lastKnownStreamConfig = null;
        this._playerInstance = null;
        this._metricsCollector = null;
        this._eventBusInstance = eventBusInstance;
        this._eventBusInstance.publish((0, $giOKx.EPlayersEvents).MODULE_LOADED, {});
        this._persistent = !!options.persistent;
    }
    setMetricsCollector(metricsCollector) {
        this._metricsCollector = metricsCollector;
    }
    destroy() {
        this._destroyPlayerInstance();
        this._isStarted = false;
        return this;
    }
    setAppKey(appKey) {
        this._appKey = appKey;
        return this;
    }
    setVideoElement(videoElement) {
        this._videoElement = videoElement;
        if (videoElement) this._playerInstance?.setVideoElement(videoElement);
        return this;
    }
    recreatePlayerInstance() {
        if (this._playerInstance) {
            this.destroy();
            this._playerInstance = null;
        }
        this._createPlayerInstance();
    }
    start() {
        if (!this._playerInstance) this.recreatePlayerInstance();
        this._playerInstance?.start();
        this._isStarted = true;
        return this;
    }
    stop() {
        this._isStarted = false;
        if (this._persistent && this._playerInstance && 'stop' in this._playerInstance) this._playerInstance.stop();
        else this._destroyPlayerInstance();
        return this;
    }
    setPlayerConfig(config) {
        this._lastKnownConfig = config;
        this._playerInstance?.setConfig(config, true);
        return this;
    }
    _destroyPlayerInstance() {
        if (!this._playerInstance) return;
        this._detachEventListeners();
        this._playerInstance.destroy();
        this._playerInstance = null;
    }
}

});

parcelRegister("h9Af4", function(module, exports) {
module.exports = import("./module.98d21018.js").then(()=>parcelRequire('2vSYt'));

});



//# sourceMappingURL=RistrettoPlaying.6832876f.js.map
